module.exports = __webpack_public_path__ + "img/1.e39978e8.png";